/* eslint-disable no-prototype-builtins */
import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import {
  Tab,
  Tabs
} from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import { BackTo } from 'components';
import RequestPromotionForm from './RequestPromotion/RequestPromotionForm';


const AutomaticPromotion = () => {
  const {profile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};
  const [activeTab, setActiveTab] = useState(permissions.promotionsRequestSimple ? 'basic' : 'complex');

  return (
    <div className="w-full pt-10 pb-25 min-h-full-screen scroll-y">
      <div className="max-w-1000 mx-auto">
        <BackTo
          link="/my-promotions"
          title={
            <div className="text-16 font-medium">
              Request Promotion
            </div>
          }
        />
      </div>
      <div className="max-w-1000 mx-auto mt-5">
        <TabContext value={activeTab}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, value) => setActiveTab(value)}
          >
            {permissions.promotionsRequestSimple &&
              <Tab
                className="capitalize font-medium"
                value="basic"
                label="Basic Promotion"
              />
            }
            {permissions.promotionsRequestCustom &&
              <Tab
                className="capitalize font-medium"
                value="complex"
                label="Complex Promotion"
              />
            }
          </Tabs>
          <TabPanel value="basic">
            {permissions.promotionsRequestSimple && <RequestPromotionForm isFormBasic />}
          </TabPanel>
          <TabPanel value="complex">
            {permissions.promotionsRequestCustom && <RequestPromotionForm isFormComplex />}
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default AutomaticPromotion;
